import {UI} from "stem-core/src/ui/UIBase.js";
import {Messages} from "../../Messages.js";
import {registerStyle} from "stem-core/src/ui/style/Theme.js";
import {BlinkInput} from "../../ui/Input.jsx";
import {styleRule} from "../../../stem-core/src/ui/Style.js";
import {authService} from "client/connection/Services.js";
import {MerchantButton} from "../../common/MerchantButton.jsx";
import {ActiveButton} from "../../ui/Button.jsx";
import {AuthStartPanelStyle} from "../../website/unauthenticated/slides/AuthStartPanel.jsx";


class CDSAccountLookupStyle extends AuthStartPanelStyle {
    @styleRule
    inputContainer = {
        display: "flex",
    };

    @styleRule
    nameInput = {
        flex: 0.7,
        marginBottom: 0,
    };

    @styleRule
    zipCodeInput = {
        marginLeft: 12,
        flex: 0.3,
        marginBottom: 0,
    };

    @styleRule
    tabs = {
        width: "100%",
        display: "flex",
        ">:first-child": {
            borderTopRightRadius: 0,
            borderBottomRightRadius: 0,
        },
        ">:last-child": {
            borderTopLeftRadius: 0,
            borderBottomLeftRadius: 0,
        }
    };

    @styleRule
    tabButton = {
        flex: 1,
    }
}

const CDS_LOGIN_METHODS = {
    nameAndZip: "nameAndZip",
    accountNumber: "accountNumber",
};

@registerStyle(CDSAccountLookupStyle)
export class CDSAccountLookup extends UI.Element {
    activeSection = CDS_LOGIN_METHODS.accountNumber;

    render() {
        const {styleSheet} = this;

        return [
            this.getHeaderSection(),
            <div className={styleSheet.inputContainer}>
                {this.renderInputSection()}
            </div>,
            <MerchantButton
                label={Messages.lookUpPrintMagazineButton}
                className={styleSheet.button}
                disabled={!this.canSubmit()}
                onClick={() => this.handleSubmit()}
            />
        ];
    }

    getHeaderSection() {
        const {styleSheet} = this;

        // TODO @cleanup seems like this should be a RadioButtonInput
        return <div className={styleSheet.tabs}>
            <ActiveButton
                className={styleSheet.tabButton}
                label={Messages.accountNumber}
                active={this.activeSection === CDS_LOGIN_METHODS.accountNumber}
                onClick={() => {
                    this.activeSection = CDS_LOGIN_METHODS.accountNumber;
                    this.redraw()
                }}/>
            <ActiveButton
                className={styleSheet.tabButton}
                label={Messages.nameAndZip}
                active={this.activeSection === CDS_LOGIN_METHODS.nameAndZip}
                onClick={() => {
                    this.activeSection = CDS_LOGIN_METHODS.nameAndZip;
                    this.redraw()
                }}/>
        </div>
    }

    renderInputSection() {
        const {styleSheet} = this;

        return (this.activeSection === CDS_LOGIN_METHODS.nameAndZip) ? [
            <BlinkInput
                ref="nameInput"
                className={styleSheet.nameInput}
                label={Messages.name}
                onEnter={() => this.handleSubmit()}
                onChange={() => this.redraw()}
            />,
            <BlinkInput
                ref="zipCodeInput"
                className={styleSheet.zipCodeInput}
                label={Messages.lookupPrintMagazineZipCode}
                onEnter={() => this.handleSubmit()}
                onChange={() => this.redraw()}
            />
        ] : [
            <BlinkInput
                ref="accountNumberInput"
                style={{flex: 1, marginBottom: 0}}
                label={Messages.accountNumber}
                onEnter={() => this.handleSubmit()}
                onChange={() => this.redraw()}
            />
        ];
    }

    canSubmit() {
        return this.activeSection === CDS_LOGIN_METHODS.nameAndZip ?
            (this.nameInput?.getValue() && this.zipCodeInput?.getValue()) : this.accountNumberInput?.getValue();
    }

    async handleSubmit() {
        if (!this.canSubmit()) {
            return;
        }
        const request = this.activeSection === CDS_LOGIN_METHODS.nameAndZip ? {
            name: this.nameInput.getValue(),
            zipCode: this.zipCodeInput.getValue(),
        } : {
            accountNumber: this.accountNumberInput.getValue(),
        };

        await authService.loginAtEndpoint("/external_providers/login_with_cds", request);
    }
}
